import { Link } from '@cian/components';
import * as React from 'react';

import { IFastLink } from '../../../common/state/app_state';
import { IJsonQuery } from '../../../json_query';
import { getTotalPagesCount } from '../../../utils/pagination';
import { trackFastLinkClick, trackFastLinksView } from './tracking';

import * as styles from './index.css';
import { mergeStyles } from '@cian/utils';

export interface IFastLinksProps {
  fastLinks: IFastLink[];
  aggregatedOffers: number;
  jsonQuery: IJsonQuery;
  offersPerPage: number;
}

export class FastLinks extends React.Component<IFastLinksProps> {
  public componentDidMount() {
    trackFastLinksView(this.getTrackingEventLabel());
  }

  public render() {
    const { fastLinks, aggregatedOffers, offersPerPage } = this.props;

    if (!fastLinks || !fastLinks.length) {
      return null;
    }

    const totalPages = getTotalPagesCount(offersPerPage, aggregatedOffers);

    return (
      <div className={styles['wrapper']}>
        <div {...mergeStyles(styles['container'], totalPages > 1 && styles['container-shifted'])}>
          <span className={styles['header']}>Вместе с этим также ищут:</span>
          {fastLinks.map(({ title, uri }, index) => (
            <Link key={index} linkStyle={styles['link']} href={uri} onClick={this.handleClick}>
              {title}
            </Link>
          ))}
        </div>
      </div>
    );
  }

  private handleClick = () => {
    trackFastLinkClick(this.getTrackingEventLabel());
  };

  private getTrackingEventLabel = (): string => {
    const { aggregatedOffers, offersPerPage } = this.props;

    return aggregatedOffers < offersPerPage + 1 ? 'withoutPagination' : 'withPagination';
  };
}
